import { Injectable } from '@angular/core';
import { FABActionDefinition, FABActionType } from '../models/fab-action.interface';

@Injectable({
	providedIn: 'root'
})
export class FABActionDefinitionsService {
	private actionDefinitions: Record<FABActionType, FABActionDefinition> = {
		SUBMIT: {
			type: 'SUBMIT',
			defaultIcon: 'paper-plane-outline',
			defaultLabel: 'Submit',
			defaultColor: 'primary',
			priority: 'primary',
			requiresConfirmation: true
		},
		UPDATE: {
			type: 'UPDATE',
			defaultIcon: 'save-outline',
			defaultLabel: 'Save',
			defaultColor: 'primary',
			priority: 'primary',
			requiresConfirmation: true
		},
		APPROVE: {
			type: 'APPROVE',
			defaultIcon: 'checkmark-circle-outline',
			defaultLabel: 'Approve',
			defaultColor: 'success',
			priority: 'primary',
			requiresConfirmation: true
		},
		CREATE: {
			type: 'CREATE',
			defaultIcon: 'add-outline',
			defaultLabel: 'Create New',
			defaultColor: 'primary',
			priority: 'primary',
			requiresConfirmation: true
		},
		FORWARD: {
			type: 'FORWARD',
			defaultIcon: 'arrow-forward-outline',
			defaultLabel: 'Forward',
			defaultColor: 'primary',
			priority: 'secondary',
			requiresConfirmation: true
		},
		SHARE: {
			type: 'SHARE',
			defaultIcon: 'share-outline',
			defaultLabel: 'Share',
			defaultColor: 'secondary',
			priority: 'secondary',
			requiresConfirmation: true
		},
		RECALL: {
			type: 'RECALL',
			defaultIcon: 'refresh-outline',
			defaultLabel: 'Recall',
			defaultColor: 'warning',
			priority: 'secondary',
			requiresConfirmation: true
		},
		RESEND: {
			type: 'RESEND',
			defaultIcon: 'mail-outline',
			defaultLabel: 'Return',
			defaultColor: 'secondary',
			priority: 'secondary',
			requiresConfirmation: true
		},
		REVERT: {
			type: 'REVERT',
			defaultIcon: 'return-down-back-outline',
			defaultLabel: 'Revert',
			defaultColor: 'warning',
			priority: 'secondary',
			requiresConfirmation: true
		},
		REPLICATE: {
			type: 'REPLICATE',
			defaultIcon: 'copy-outline',
			defaultLabel: 'Replicate',
			defaultColor: 'secondary',
			priority: 'tertiary',
			requiresConfirmation: true
		},
		DELETE: {
			type: 'DELETE',
			defaultIcon: 'trash-outline',
			defaultLabel: 'Delete',
			defaultColor: 'danger',
			priority: 'tertiary',
			requiresConfirmation: true
		},
		SUBMIT_WEBC: {
			type: 'SUBMIT_WEBC',
			defaultIcon: 'globe-outline',
			defaultLabel: 'Submit (WebC)',
			defaultColor: 'primary',
			priority: 'secondary',
			requiresConfirmation: true
		}
	};

	getActionDefinition(type: FABActionType): FABActionDefinition {
		return this.actionDefinitions[type];
	}

	getAllDefinitions(): Record<FABActionType, FABActionDefinition> {
		return { ...this.actionDefinitions };
	}

	getActionsByPriority(priority: 'primary' | 'secondary' | 'tertiary'): FABActionDefinition[] {
		return Object.values(this.actionDefinitions).filter((action) => action.priority === priority);
	}
}
